import { ChangeEvent } from 'react';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { TempRegField } from '@/utils/integrations';
import Button from '@ui/buttons/button/button';

interface Props {
  setQuery: (field: string, value: string) => void;
  field: TempRegField;
  error: boolean;
  deleteQuery: () => void;
  disabled?: boolean;
}

const QueriesMapping = ({ field, setQuery, error, deleteQuery, disabled }: Props) => {
  const handleQueryKey = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    setQuery(value, field.value);
  };

  const handleQueryValue = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    setQuery(String(field.field), value);
  };

  return (
    <div className="grid-row margin-b-16">
      <InputWithOverlay
        inputProps={{
          defaultValue: field.field,
          placeholder: 'Enter a key name',
          onBlur: handleQueryKey,
          disabled: disabled,
          style: { fontFamily: 'monospace' },
        }}
        error={error}
      />

      <InputWithOverlay
        inputProps={{
          defaultValue: field.value,
          placeholder: 'Enter a mapped value',
          onBlur: handleQueryValue,
          disabled: disabled,
          style: { fontFamily: 'monospace' },
        }}
        error={error}
      />

      {!disabled && (
        <Button clear className="close-integration flex fd-column jc-center" onClick={deleteQuery}>
          <Icon name={ICONS.CLOSE} size={14} color={'white'} />
        </Button>
      )}
    </div>
  );
};

export default QueriesMapping;
